import React, { useEffect, useState } from "react";
import Element from 'src/components/element';
import View from 'src/components/view';
import utils from 'src/components/utils';

function PrepararContratos() {
  let [view, setView] = useState({});
  let [crud, setCrud] = useState({ data: {}, changed: {} });
  let idCliente = utils.getPath(3);
  let [ready, setReady] = useState(false);
  let [index, setIndex] = useState(0);

  const carregarCliente = function () {
    if (!idCliente) {
      idCliente = 0;
    }
    utils.execute(crud, 'Cliente?single=true&id=' + idCliente, null, function (res) {
      crud.data = res.data;
      crud.changed = res.data;

      setCrud(crud);
      setIndex(index + 1);
    }, true);
  }

  useEffect(() => {
    if (!ready) {
      ready = true;
      setReady(true);
      carregarCliente();
    }
  });

  crud.abrirContrato = function (el, cfg) {
    let cr = cfg.data;
    window.location.href = '/contratos/' + cr.id + '/assinaturas/' + idCliente + '/prepare'
  }

  let ctrs = {
    elements: {
      detail: { label: 'Preparar Contratos Para Assinatura' },
      dados: {
        type: 'card',
        elements: {
          nome: { type: 'span', field: 'nome', value: '${@this.codigo + " - " + @this.nome}', space: 8 }
        }
      },
      itens: {
        type: 'list',
        header: false,
        name: 'contratos',
        list: {
          url: 'listarContratosPorPais',
          send: {
            id_cliente: idCliente
          }
        },
        print: false,
        size: -1,
        paginate: false,
        search: false,
        controls: false,
        columns: {
          nome: {},
          acoes: {
            field: 'aaa',
            columnStyle: { width: '40px' },
            elements: {
              download: {
                type: 'button',
                rendered: '${@this.preparar && exists(@this,"id_fonte_dados")}',
                icon: 'fa fa-arrow-right',
                click: {
                  action: 'abrirContrato'
                }
              }
            }
          }
        }
      }
    }
  };

  return (
    <View name="ui-contratos" view={view}>
      <Element value={ctrs} crud={crud} data={crud.data} view={view} ></Element>
    </View >
  );
}

export default PrepararContratos;